import { render, staticRenderFns } from "./AlarmSetting.vue?vue&type=template&id=06cf9442&scoped=true"
import script from "./AlarmSetting.vue?vue&type=script&lang=js"
export * from "./AlarmSetting.vue?vue&type=script&lang=js"
import style0 from "./AlarmSetting.vue?vue&type=style&index=0&id=06cf9442&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf9442",
  null
  
)

export default component.exports